const layerPointStyle = {
  id: 'point',
  type: 'circle',
  paint: {
    'circle-radius': 8,
    'circle-color': [
      'case',
      ["boolean", ["feature-state", "selected"], false],
      "#00fad5",
      ["boolean", ["feature-state", "hover"], false],
      '#00a2fa',
      '#007cbf'
    ]
  }
};

export default layerPointStyle